import * as React from 'react';
import * as S from './icon.styles';
const getIconHtmlElement = ({ source, hideForScreenReader = true }, tag) => {
    switch (tag) {
        case 'div':
            return React.createElement(S.DivIconHtmlElement, { "aria-hidden": hideForScreenReader, dangerouslySetInnerHTML: { __html: source } });
        case 'span':
            return React.createElement(S.SpanIconHtmlElement, { "aria-hidden": hideForScreenReader, dangerouslySetInnerHTML: { __html: source } });
        case 'i':
            return React.createElement(S.IIconHtmlElement, { "aria-hidden": hideForScreenReader, dangerouslySetInnerHTML: { __html: source } });
        default:
            return React.createElement(S.DivIconHtmlElement, { "aria-hidden": hideForScreenReader, dangerouslySetInnerHTML: { __html: source } });
    }
};
const Icon = ({ icon, width, height, className = '', tag = 'div', noDefaultSize = false, ariaLabel }) => {
    var _a;
    const hasNoSize = !width && !height && !noDefaultSize;
    return (React.createElement(React.Fragment, null,
        getIconHtmlElement(icon, tag),
        React.createElement(S.IconSVG, { "aria-hidden": (_a = icon.hideForScreenReader) !== null && _a !== void 0 ? _a : true, "aria-label": ariaLabel, hasNoSize: hasNoSize, className: `svg-icon svg-icon-${icon.name.toLowerCase()} ${className}`, width: width, height: height },
            React.createElement("use", { xlinkHref: `#${icon.name}` }))));
};
export default Icon;
//# sourceMappingURL=Icon.js.map